import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import Hero from '../../Hero';
import BackgroundImage from '../../BackgroundImage';
import styles from './HeroFull2.module.scss';

const HeroFull = ({ children, className, image, mobileImage }) => {
  return (
    <Hero className={className}>
      <ItemBreakpoint breakpoint={'lg'}>
        <BackgroundImage image={image}>{children}</BackgroundImage>
        <BackgroundImage image={mobileImage}>{children}</BackgroundImage>
      </ItemBreakpoint>
    </Hero>
  );
};

export default HeroFull;
